import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Product } from './product';
import { FamilyView, FamilyViewProxy } from '../views/family';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { ProductType } from '../types';
import { FamilyProductType } from '../types';
import { FamilyPeriodType } from '../types';

const _schema = {
    "name": "FAMILY",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "product", type: "objid" },
        { name: "allday", type: "boolean" }
    ],
    relate: [
        { direction: ">", target: "PRODUCT", by: "product", name: "product", reason: "product", child: false, class: ProductType },
        { direction: "<", target: "FAMILYPRODUCT", by: "family", name: "product", reason: "products", child: true, class: FamilyProductType },
        { direction: "<", target: "FAMILYPERIOD", by: "family", name: "period", reason: "periods", child: true, class: FamilyPeriodType }
    ]
} as const;

const _FamilyClass = CreateObject(_schema);
if (!_FamilyClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class Family extends _FamilyClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Family {
        return this._Copy(store) as Family;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'product' && related instanceof Product){
            if (related === this.product){
                related.AddFamily(this);
            }
        }
    }

    override get viewProxy(): FamilyView {
        return FamilyViewProxy(this, this.data);
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

